<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <form data-vv-scope="matchForm">
            <v-flex xs12>
              <v-card>
                <v-toolbar dense color="grey lighten-3" flat>
                  <v-icon>mdi-pencil</v-icon>
                  <v-toolbar-title>Edit Match Transaction </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="matchForm.branchDesc"
                          :label="matchFormLabel.branchDesc"
                          readonly
                          disabled
                          data-vv-name="matchForm.branchDesc"
                          :data-vv-as="matchFormLabel.branchDesc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md1 xs12>
                        <v-text-field
                          v-model="matchForm.transactionTypeDesc"
                          :label="matchFormLabel.transactionType"
                          readonly
                          disabled
                          data-vv-name="matchForm.transactionTypeDesc"
                          :data-vv-as="matchFormLabel.transactionType"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md5 xs12>
                        <v-text-field
                          v-model="matchForm.documentNo"
                          :label="matchFormLabel.documentNo"
                          readonly
                          disabled
                          data-vv-name="matchForm.documentNo"
                          :data-vv-as="matchFormLabel.documentNo"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <cal-picker
                          v-model="matchForm.transactionDate"
                          :label="matchFormLabel.transactionDate"
                          readonly
                          disabled
                          :data-vv-as="matchFormLabel.transactionDate"
                          data-vv-name="matchForm.transactionDate"
                        ></cal-picker>
                      </v-flex>
                      <v-flex md3 xs12>
                        <v-text-field
                          v-model="matchForm.accountingYear"
                          :label="matchFormLabel.accountingYear"
                          readonly
                          disabled
                          data-vv-name="matchForm.accountingYear"
                          :data-vv-as="matchFormLabel.accountingYear"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md3 xs12>
                        <v-text-field
                          v-model="matchForm.accountingMonth"
                          :label="matchFormLabel.accountingMonth"
                          readonly
                          disabled
                          data-vv-name="matchForm.accountingMonth"
                          :data-vv-as="matchFormLabel.accountingMonth"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="matchForm.accountNoDesc"
                          :label="matchFormLabel.accountNoDesc"
                          readonly
                          disabled
                          data-vv-name="matchForm.accountNoDesc"
                          :data-vv-as="matchFormLabel.accountNoDesc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md3 xs12>
                        <v-text-field
                          v-model="matchForm.fundDesc"
                          :label="matchFormLabel.fundDesc"
                          readonly
                          disabled
                          data-vv-name="matchForm.fundDesc"
                          :data-vv-as="matchFormLabel.fundDesc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md3 xs12>
                        <v-text-field
                          v-model="matchForm.suffixDesc"
                          :label="matchFormLabel.suffixDesc"
                          readonly
                          disabled
                          data-vv-name="matchForm.suffixDesc"
                          :data-vv-as="matchFormLabel.suffixDesc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="matchForm.gstIODesc"
                          :label="matchFormLabel.gstIO"
                          readonly
                          disabled
                          data-vv-name="matchForm.gstIODesc"
                          :data-vv-as="matchFormLabel.gstIO"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md3 xs12>
                        <v-text-field
                          v-model="matchForm.gstStatDesc"
                          :label="matchFormLabel.gstStat"
                          readonly
                          disabled
                          data-vv-name="matchForm.gstStatDesc"
                          :data-vv-as="matchFormLabel.gstStat"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md3 xs12>
                        <v-text-field
                          v-model="matchForm.gstRate"
                          :label="matchFormLabel.gstRate"
                          readonly
                          disabled
                          data-vv-name="matchForm.gstRate"
                          :data-vv-as="matchFormLabel.gstRate"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-text-field
                          v-model="matchForm.netAmtCurrDesc"
                          :label="matchFormLabel.netAmtCurr"
                          readonly
                          disabled
                          data-vv-name="matchForm.netAmtCurrDesc"
                          :data-vv-as="matchFormLabel.netAmtCurr"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="matchForm.netAmt"
                          :label="matchFormLabel.netAmt"
                          readonly
                          disabled
                          data-vv-name="matchForm.netAmt"
                          :data-vv-as="matchFormLabel.netAmt"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md1 xs12>
                        <v-checkbox
                          color="primary"
                          :label="matchFormLabel.netAmtLocAE"
                          readonly
                          disabled
                          v-model="matchForm.netAmtLocAE"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex md5 xs12>
                        <v-text-field
                          v-model="matchForm.netAmtLoc"
                          :label="matchFormLabel.netAmtLoc"
                          readonly
                          disabled
                          data-vv-name="matchForm.netAmtLoc"
                          :data-vv-as="matchFormLabel.netAmtLoc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="matchForm.balOS"
                          :label="matchFormLabel.balOS"
                          readonly
                          disabled
                          data-vv-name="matchForm.balOS"
                          :data-vv-as="matchFormLabel.balOS"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-text-field
                          v-model="matchForm.balOSLoc"
                          :label="matchFormLabel.balOSLoc"
                          readonly
                          disabled
                          data-vv-name="matchForm.balOSLoc"
                          :data-vv-as="matchFormLabel.balOSLoc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6 xs12>
                        <v-autocomplete
                          :items="matchOn"
                          v-model="matchForm.matchOn"
                          :label="matchFormLabel.matchOn"
                          item-text="label"
                          item-value="value"
                          data-vv-name="matchForm.matchOn"
                          :data-vv-as="matchFormLabel.matchOn"
                          @change="doStoreData()"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex md6 xs12>
                        <cal-picker
                          v-model="matchForm.matchedRecTransDate"
                          @change="checkDate(), doStoreData()"
                          :label="matchFormLabel.matchedRecTransDate"
                          data-vv-name="matchForm.matchedRecTransDate"
                          :data-vv-as="matchFormLabel.matchedRecTransDate"
                          :error-messages="errors.collect('matchForm.matchedRecTransDate')"
                          :min="this.parseDateISO(this.tDateRange.effDate)"
                          :max="this.parseDateISO(this.tDateRange.expDate)"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="this.matchData.action === 'M'">
                      <v-flex xs12>
                        <v-btn class="mr-2" color="info" dark @click.prevent="doViewFullDetail">
                          {{ actionLabel.fullDetail }}
                          <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
                        </v-btn>
                        <v-btn class="mr-2" color="primary" dark @click.prevent="doSelectTransToMatch">
                          {{ actionLabel.transToMatch }}
                          <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
                        </v-btn>
                        <v-btn color="red" dark @click.prevent="doClearSelectedMatch">
                          {{ actionLabel.clear }}
                          <v-icon dark right>mdi-eraser</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 class="mt-3">
                        <v-card>
                          <v-data-table
                            :headers="matchDetailColumns"
                            :items="matchForm.matchDetItems"
                            :footer-props="{'items-per-page-options': itemsPerPage }"
                            v-bind:options.sync="matchDetPagination"
                            item-key="key"
                            :loading="loading"
                            :no-data-text="noDataText"
                            class="elevation-1"
                          >
                            <template v-slot:item="row">
                              <tr>
                                <td>{{ row.item.tranDate }}</td>
                                <td>{{ row.item.polNo }}</td>
                                <td>{{ row.item.branch }}</td>
                                <td>{{ row.item.type }}</td>
                                <td>{{ row.item.docNo }}</td>
                                <td>{{ row.item.fund }}</td>
                                <td>{{ row.item.suffix }}</td>
                                <td>{{ row.item.curr }}</td>
                                <td>
                                  <v-edit-dialog
                                    >{{ row.item.rsMatchAmt }}
                                    <template slot="input">
                                      <v-text-field
                                        ref="elMatchAmt"
                                        v-model="row.item.rsMatchAmt"
                                        label="Edit"
                                        single-line
                                        counter
                                        clearable
                                        :loading="loading"
                                        @keypress="checkNegValue($event)"
                                        @change="doEditMatchAmt(row.item)"
                                      ></v-text-field>
                                    </template>
                                  </v-edit-dialog>
                                </td>
                                <td>{{ row.item.rsOsBal }}</td>
                                <td>{{ row.item.rsLocOSBal }}</td>
                                <td>
                                  <v-btn color="green darken-1" text @click.prevent="doDetail(row.item)">{{ row.item.detail }} </v-btn>
                                </td>
                                <td class="table-action-header">
                                  <table-action :rowData="row" remove @remove="doDeleteMatch(row.item)"></table-action>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-text-field
                          v-model="matchForm.totalMatchAmountCurrDesc"
                          :label="matchFormLabel.totalMatchAmountCurr"
                          readonly
                          data-vv-name="matchForm.totalMatchAmountCurrDesc"
                          :data-vv-as="matchFormLabel.totalMatchAmountCurr"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md5 xs12>
                        <v-text-field
                          v-model="matchForm.totalMatchAmount"
                          :label="matchFormLabel.totalMatchAmount"
                          readonly
                          data-vv-name="matchForm.totalMatchAmount"
                          :data-vv-as="matchFormLabel.totalMatchAmount"
                          :loading="calculLoading"
                        ></v-text-field>
                      </v-flex>
                      <!--
                      <v-flex md2 xs12>
                        <v-text-field v-model="matchForm.totalMatchAmountLocalCurr" :label="matchFormLabel.totalMatchAmountLocalCurr" readonly data-vv-name="matchForm.totalMatchAmountLocalCurr" :data-vv-as="matchFormLabel.totalMatchAmountLocalCurr"></v-text-field>
                      </v-flex>
                      -->
                      <v-flex md5 xs12>
                        <v-text-field
                          v-model="matchForm.totalMatchAmountLocal"
                          :label="matchFormLabel.totalMatchAmountLocal"
                          readonly
                          data-vv-name="matchForm.totalMatchAmountLocal"
                          :data-vv-as="matchFormLabel.totalMatchAmountLocal"
                          :loading="calculLoading"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-text-field
                          v-model="matchForm.baseMatchAmountCurrDesc"
                          :label="matchFormLabel.baseMatchAmountCurr"
                          readonly
                          data-vv-name="matchForm.baseMatchAmountCurrDesc"
                          :data-vv-as="matchFormLabel.baseMatchAmountCurr"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md5 xs12>
                        <v-text-field
                          v-model="matchForm.baseMatchAmount"
                          :label="matchFormLabel.baseMatchAmount"
                          readonly
                          data-vv-name="matchForm.baseMatchAmount"
                          :data-vv-as="matchFormLabel.baseMatchAmount"
                          :loading="calculLoading"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md5 xs12>
                        <v-text-field
                          v-model="matchForm.baseMatchAmountLocal"
                          :label="matchFormLabel.baseMatchAmountLocal"
                          readonly
                          data-vv-name="matchForm.baseMatchAmountLocal"
                          :data-vv-as="matchFormLabel.baseMatchAmountLocal"
                          :loading="calculLoading"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <h3><u>Base Transaction after matching </u></h3>
                      </v-flex>
                      <v-flex md2 xs12>
                        <v-text-field
                          v-model="matchForm.balanceOutStandingCurrDesc"
                          :label="matchFormLabel.balanceOutStandingCurrDesc"
                          readonly
                          data-vv-name="matchForm.balanceOutStandingCurr"
                          :data-vv-as="matchFormLabel.balanceOutStandingCurr"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md5 xs12>
                        <v-text-field
                          v-model="matchForm.balanceOutStanding"
                          :label="matchFormLabel.balanceOutStanding"
                          readonly
                          data-vv-name="matchForm.balanceOutStanding"
                          :data-vv-as="matchFormLabel.balanceOutStanding"
                          :loading="calculLoading"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md5 xs12>
                        <v-text-field
                          v-model="matchForm.balanceOutStandingLocal"
                          :label="matchFormLabel.balanceOutStandingLocal"
                          readonly
                          data-vv-name="matchForm.balanceOutStandingLocal"
                          :data-vv-as="matchFormLabel.balanceOutStandingLocal"
                          :loading="calculLoading"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
              <v-spacer class="mt-3"></v-spacer>
                    <v-btn class="mr-2" color="red" dark @click.prevent="doCancel">
                      {{ actionLabel.cancel }}
                      <v-icon dark right>mdi-exit-to-app</v-icon>
                    </v-btn>
                    <v-btn class="mr-2" color="green" dark @click.prevent="doMatchSave">
                      {{ actionLabel.matchSave }}
                      <v-icon dark right>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn color="primary" dark @click.prevent="doCalculate">
                      {{ actionLabel.calculate }}
                      <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
                    </v-btn>
            </v-flex>
          </form>
        </v-flex>
      </v-layout>
      <v-dialog v-model="showSelectTransToMatch" width="1280px">
        <select-trans-to-match
          v-if="showSelectTransToMatch"
          @close="showSelectTransToMatch = false"
          :matchDetItems="this.matchForm.matchDetItems"
          @assign-matchSelected="assignMatchSelected"
        ></select-trans-to-match>
      </v-dialog>

      <v-dialog v-model="showErrorDialog" width="800px" persistent>
        <acct-info-dialog :messageData="messages" @close="showErrorDialog = false"></acct-info-dialog>
      </v-dialog>

      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <warning v-model="promptDialog">{{ warnMsg }}</warning>
      <confirm v-model="promptSaveMatch" @ok="saveMatchAcct">Confirm Match and Save? </confirm>
      <confirm v-model="promptProceed" @ok="doProceed"> Match Amount exceeds Base OS Balance (220059). Do you comfirm to proceed? </confirm>

      <prompt-leave
        v-if="showPromptLeave"
        v-model="promptLeave"
        @exit="doMatchExit"
      ></prompt-leave>

    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { matchViewMixin } from '@/mixins/accounting/match/matchViewMixin'
import { matchAjaxMixin } from '@/mixins/accounting/match/matchAjaxMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { matchListMixin } from '@/mixins/accounting/match/matchListMixin'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import isAfter from 'date-fns/isAfter'
import { parseISO } from 'date-fns'
import { ACCOUNTS_LOAD_DATA, MATCH_DATA_EDIT, INDIC_UNLOCK, CHG_ACCT_MCH_BASE, CHG_ACCT_MCH_CANCEL } from '@/store/types'
import SelectTransToMatch from '@/components/core/accounting/match/SelectTransToMatch'
import { formatDisplayDateTime2, removeTime } from '@/utils/date'
import AcctInfoDialog from '@/components/core/accounting/dialog/AcctInfoDialog'
import { removeFormatNumber } from '@/utils/number'
import { formatPrice } from '@/utils/index'
import PromptLeave from '@/components/core/accounting/match/prompt/PromptLeave'
import { promptOnExitMixin } from '@/mixins/accounting/match/promptOnExitMixin'

export default {
  data() {
    return {
      trandaterange: {},
      miscacctparams: [],
      branches: [],
      accounts: [],
      funds: [],
      acctnosuffixes: [],
      promptSaveMatch: false,
      promptProceed: false,
      showErrorDialog: false,
      showPromptLeave: true,
      actionLabel: {
        fullDetail: 'Full Details',
        transToMatch: 'Select Trans to match',
        calculate: 'Calculate',
        matchSave: 'Match & Save',
        cancel: 'Cancel',
        clear: 'Clear All'
      },
      matchInfo: {
        branch: '',
        acctNo: '',
        type: '',
        docNo: '',
        fund: '',
        suffix: '',
        transfer: ''
      },
      showSelectTransToMatch: false,
      selectedMatchDetItems: [],
      loading: false,
      calculLoading: false,
      processingFlag: false,
      promptDialog: false,
      warnMsg: 'No transaction to match',
      matchDetPagination: {
        page: 1
      }
    }
  },
  computed: {
    acctMaster() {
      return this.$store.state.accounts.acctMaster
    },
    isUnlock() {
      return this.$store.state.matching.recLock.isUnlock
    },
    matchData() {
      return this.$store.state.matching.matchData
    },
    matchSelectedList() {
      return this.$store.state.matching.matchSelectedList.selectedMatchListing
    },
    tDateRange() {
      return this.trandaterange
    },
    displayErrorDialog() {
      return this.messages
    },
    valTranDateMin() {
      if (this.matchForm.matchTransMinDate !== '' && this.matchForm.matchTransMinDate !== null) {
        const result = 'entry|valTranDateMin: ' + this.matchForm.matchTransMinDate
        return result
      } else {
        return 'required'
      }
    },
    matchFileName() {
      return this.$store.state.accounts.acctMchObj.matchFileName
    },
    baseFromMatch() {
      return this.$store.state.accounts.acctMchObj.baseFromMatch
    },
    isCancel() {
      return this.$store.state.accounts.acctMchObj.isCancel
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      this.skipPrompt = false
      this.processingFlag = true
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('reportsInit')])
      await Promise.all([this.$store.dispatch('acctReportsInit')])
      await Promise.all([this.$store.dispatch('accountsInit')])
      await Promise.all([this.$store.dispatch('performMatchInit')])
      this.getAcctPaytVouMenuLink()
      this.getAcctRptMenuLink()
      this.getAcctCreditNoteMenuLink()
      this.getAcctDebitNoteMenuLink()
      this.matchForm.transactionDate = new Date()
      this.getCommonData('trandaterange', '009')
      this.getCommonData('miscacctparams')
      this.getCommonData('branches')
      this.getCommonDataList('accounts')
      this.getCommonDataList('acctnosuffixes')
      this.getCommonDataList('funds')
      this.getBranchList()
      this.performReview().then((result) => {
        if (result) {
          this.matchForm.matchOn = this.miscacctparams.defMchOn
          this.matchForm.totalMatchAmountCurr = this.matchForm.netAmtCurr
          this.matchForm.totalMatchAmountCurrDesc = this.matchForm.netAmtCurrDesc
          this.matchForm.balanceOutStanding = this.matchForm.balOS
          this.matchForm.balanceOutStandingLocal = this.matchForm.balOSLoc
          this.doAssignSelectedDetail()
        }
      })
      this.matchForm.matchTransMinDate = this.parseDateISO(this.tDateRange.effDate)
      this.matchForm.matchTransMaxDate = this.parseDateISO(this.tDateRange.expDate)
      this.processingFlag = false
      this.initCommonUtilMenu()
      this.$store.commit(CHG_ACCT_MCH_BASE, true)
      this.$store.commit(MATCH_DATA_EDIT, this.matchForm)
    },
    checkDate() {
      this.ValidateTranDateRange(this.matchForm.matchedRecTransDate, '009')
    },
    doViewFullDetail() {
      let tranType = this.matchData.type.split(' ')
      this.matchInfo.branch = this.matchData.branch
      this.matchInfo.acctNo = this.matchData.accountNo
      this.matchInfo.type = tranType[0].trim()
      this.matchInfo.docNo = this.matchData.documentNo
      this.matchInfo.fund = this.matchData.fund
      this.matchInfo.suffix = this.matchData.suffix
      this.matchInfo.transfer = 'matchTrans'
      // this.doStoreData()
      this.$store.commit(ACCOUNTS_LOAD_DATA, this.matchInfo)
      this.skipPrompt = true
      this.$router.push({ name: 'accountsDetails', params: { accountData: this.matchInfo } }).catch(() => {})
    },
    doDetail(data) {
      this.matchInfo.branch = data.branch
      this.matchInfo.acctNo = data.acctNo
      this.matchInfo.type = data.tranType
      this.matchInfo.docNo = data.docNo
      this.matchInfo.fund = data.fund
      this.matchInfo.suffix = data.suffix
      this.matchInfo.transfer = 'matchTrans'
      this.$store.commit(ACCOUNTS_LOAD_DATA, this.matchInfo)
      this.$store.commit(INDIC_UNLOCK, true)
      this.skipPrompt = true
      this.$router.push({ name: 'accountsDetails', params: { accountData: this.matchInfo } }).catch(() => {})
    },
    doStoreData() {
      const data = {
        matchOn: this.matchForm.matchOn,
        matchedRecTransDate: this.matchForm.matchedRecTransDate
      }
      this.$store.commit(MATCH_DATA_EDIT, data)
    },
    doSelectTransToMatch() {
      this.loading = true
      this.ValidateTranDateRange(this.matchForm.matchedRecTransDate, '009').then((result) => {
        if (result) {
          this.showSelectTransToMatch = true
          this.loading = false
        }
      })
    },
    checkNegValue(data) {
      if (data.key === '-') {
        const errMsg = {
          messages: [{ message: 'Cannot enter negative value', type: 'ERROR' }]
        }
        this.message(errMsg)
        this.fieldMessage(errMsg)
      }
    },
    doEditMatchAmt(data) {
      for (var i = 0; i < this.matchForm.matchDetItems.length; i++) {
        if (
          this.matchForm.matchDetItems[i].polNo === data.polNo &&
          this.matchForm.matchDetItems[i].branch === data.branch &&
          this.matchForm.matchDetItems[i].type === data.type &&
          this.matchForm.matchDetItems[i].docNo === data.docNo &&
          this.matchForm.matchDetItems[i].fund === data.fund &&
          this.matchForm.matchDetItems[i].suffix === data.suffix
        ) {
          this.matchForm.matchDetItems[i].isEditMatchAmt = 'true'
          if (removeFormatNumber(data.rsMatchAmt) > 0 || removeFormatNumber(data.rsMatchAmt) < 0) {
            if (removeFormatNumber(data.osBal) > 0 && removeFormatNumber(data.rsMatchAmt) < 0) {
              this.matchForm.matchDetItems[i].rsMatchAmt = formatPrice(removeFormatNumber(data.rsMatchAmt) * -1.0)
            } else if (removeFormatNumber(data.osBal) < 0 && removeFormatNumber(data.rsMatchAmt) > 0) {
              this.matchForm.matchDetItems[i].rsMatchAmt = formatPrice(removeFormatNumber(data.rsMatchAmt) * -1.0)
            } else {
              this.matchForm.matchDetItems[i].rsMatchAmt = formatPrice(data.rsMatchAmt)
            }
          } else {
            this.matchForm.matchDetItems[i].rsMatchAmt = '0.00'
          }
          /* this.$refs.elMatchAmt.$el.cleave.setRawValue(this.matchForm.matchDetItems[i].rsMatchAmt)
          this.matchForm.matchDetItems[i].rsMatchAmt = formatPrice(this.$refs.elMatchAmt.$el.cleave.getRawValue())
          */
        }
      }
      sessionStorage.setItem('matchList', JSON.stringify(this.matchForm.matchDetItems))
      this.doCalculate()
    },
    doDeleteMatch(data) {
      for (var i = 0; i < this.matchForm.matchDetItems.length; i++) {
        if (
          this.matchForm.matchDetItems[i].polNo === data.polNo &&
          this.matchForm.matchDetItems[i].branch === data.branch &&
          this.matchForm.matchDetItems[i].type === data.type &&
          this.matchForm.matchDetItems[i].docNo === data.docNo &&
          this.matchForm.matchDetItems[i].fund === data.fund &&
          this.matchForm.matchDetItems[i].suffix === data.suffix
        ) {
          this.$delete(this.matchForm.matchDetItems, i)
        }
      }
      sessionStorage.setItem('matchList', JSON.stringify(this.matchForm.matchDetItems))
      this.selectedList = []
      this.calculateBaseAmountData()
    },
    doCalculate() {
      this.matchForm.matchDetItems = []
      let list = JSON.parse(sessionStorage.getItem('matchList'))
      if (list !== null) {
        this.createMatchList(list)
      }
    },
    doMatchSave() {
      if (this.matchForm.matchDetItems.length > 0) {
        this.promptSaveMatch = true
      } else {
        this.promptDialog = true
      }
    },
    saveMatchAcct() {
      const debitArray = ['A', 'H', 'M', 'N', 'O', 'P', 'Q', 'Z']
      const creditArray = ['B', 'I', 'R', 'S', 'T', 'U', 'V', 'X', 'Y']
      var existLimit = false

      debitArray.forEach((item) => {
        if (item === this.matchForm.transactionType.substring(0, 1) && removeFormatNumber(this.matchForm.balanceOutStanding) < 0) {
          existLimit = true
        }
      })
      creditArray.forEach((item) => {
        if (item === this.matchForm.transactionType.substring(0, 1) && removeFormatNumber(this.matchForm.balanceOutStanding) > 0) {
          existLimit = true
        }
      })
      if (existLimit) {
        this.promptProceed = true
      } else {
        this.doProceed()
      }
    },
    doProceed() {
      this.skipPrompt = true
      this.matchForm.actionName = 'SAVE_MATCH'
      this.matchForm.action = this.matchData.action
      this.processingFlag = true
      // OS-491: Uncommented line 438
      this.performSave()
    },
    doCancel() {
      this.$store.commit(CHG_ACCT_MCH_CANCEL, true)
      this.promptLeave = true
    },
    doClearSelectedMatch() {
      this.matchForm.matchDetItems = []
      sessionStorage.setItem('matchList', JSON.stringify(this.matchForm.matchDetItems))
      this.calculateBaseAmountData()
    },
    doAssignSelectedDetail() {
      // if (this.matchDataEdit.matchOn !== '' && this.matchDataEdit.matchedRecTransDate !== '') {
      //   if (this.matchDataEdit.matchOn !== undefined && this.matchDataEdit.matchedRecTransDate !== undefined) {
      //     this.matchForm.matchOn = this.matchDataEdit.matchOn
      //     this.matchForm.matchedRecTransDate = this.matchDataEdit.matchedRecTransDate
      //   }
      // }
      this.matchForm.matchDetItems = []
      let list = JSON.parse(sessionStorage.getItem('matchList'))
      if (list !== null) {
        this.matchForm.matchDetItems = list
        this.calculateBaseAmountData()
      }
    },
    assignMatchSelected(list) {
      this.selectedMatchDetItems = []
      list.map((result) => {
        const resultList = {
          tranDate: result.tranDate,
          polNo: result.polNo,
          acctNo: result.acctNo,
          branch: result.branch,
          type: result.type,
          docNo: result.docNo,
          fund: result.fund,
          suffix: result.suffix,
          curr: result.curr,
          netAmt: result.netAmt,
          osBal: result.osBal,
          locOsBal: result.locOsBal,
          tranType: result.tranType,
          comm: result.comm,
          originalLocOsBal: result.originalLocOsBal,
          currRate: result.currRate
        }
        this.selectedMatchDetItems.push(resultList)
      })
      this.createMatchList(this.selectedMatchDetItems)
    },
    createMatchList(data) {
      this.loading = true
      let list = data
      this.selectedList = []
      this.calculateSelectedData(
        list,
        formatDisplayDateTime2(this.matchForm.matchedRecTransDate),
        this.matchForm.matchOn,
        this.matchForm.balOS,
        this.matchForm.netAmtCurr
      ).then((result) => {
        if (result) {
          sessionStorage.setItem('matchList', JSON.stringify(this.matchForm.matchDetItems))
          this.calculateBaseAmountData().then((result) => {
            if (result) {
              this.loading = false
            }
          })
        }
      })
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    closeDialog() {
      this.promptDialog = false
    }
  },
  mounted() {
    this.doInit()
  },
  created() {
    this.$validator.extend('valTranDateMin', {
      getMessage(field, args) {
        return `00017 - Date is not within permitted Date Range. Please check the Transaction Date Range parameters. (17)`
      },
      validate(value, args) {
        if (args === void 0) args = []
        var transMinDate = args[0]
        if (transMinDate) {
          return !isAfter(removeTime(value), removeTime(transMinDate))
        }
      }
    })
  },
  mixins: [MessageMixin, routeMixin, matchViewMixin, matchAjaxMixin, commonAjaxMixin, matchListMixin, recordLockMixin, promptOnExitMixin],
  components: {
    SelectTransToMatch,
    AcctInfoDialog,
    PromptLeave
  }
}
</script>

<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
